import type { AxiosError } from 'axios';

/**
 * Pulls the human-readable messages off a rejected label write.
 *
 * The endpoint answers a rejected rename with 422 and an `errors` array naming the offending
 * column. Returns an empty array for anything else — a network failure or a 500 has no
 * column-level detail to show, so the caller falls back to a generic message.
 */
export const extractLabelErrors = (error: unknown): string[] => {
  const { errors } = (error as AxiosError<{ errors?: unknown }>)?.response?.data ?? {};

  if (Array.isArray(errors)) {
    return errors.filter((message): message is string => typeof message === 'string' && message !== '');
  }

  return typeof errors === 'string' && errors !== '' ? [errors] : [];
};
